<info class="info">
    <header class="info-heading">
        <h1>Trækningslisten</h1>
    </header>
    <content class="info-content mt-0">
        <p class="info-content-text">Hver måned offentliggøres de udtrukne lodnumre digitalt på vores hjemmeside og udvalgte numre på tekst-tv. Lodnumrene offentliggøres i én samlet trækningsliste d. 15. hver måned.</p>
        <h4 class="info-content-title">Sådan læser du listen</h4>
        <p class="info-content-text">For alle gevinster over 1.200 kr. står de vindende lodnumre under overskriften med gevinstens størrelse. Lodnumrene er skrevet i rækkefølge med det laveste nummer øverst til venstre og det højeste nummer nederst til højre.​ Gevinster på 1.200 kr. og lavere vises med de tre første cifre i lodnummeret skrevet med fed, og de tre sidste cifre i lodnummeret med almindelig skrift herunder.</p>
        <p class="info-content-contact">
            Har du spørgsmål til vores trækninger eller brug for hjælp til trækningslisten – så kontakt kundeservice via vores chat, mail eller telefon: <a href="TEL:33420900">3342 0900</a>
        </p>
    </content>
    
</info>
